export type Recurrence = {unit:"day"|"week"|"month"|"year";interval:number};
export const recurrenceUnits={day:"Tag(e)",week:"Woche(n)",month:"Monat(e)",year:"Jahr(e)"} as const;
export function validCalendarDate(value:string):boolean {
  if(!/^\d{4}-\d{2}-\d{2}$/.test(value))return false;
  const date=new Date(value+"T12:00:00Z");
  return Number.isFinite(date.getTime())&&date.toISOString().slice(0,10)===value;
}
/** Always shift the original anchor, so Jan 31 -> Feb 28 -> Mar 31. */
export function advanceDate(anchor:string,rule:Recurrence,occurrence:number):string {
  if(!validCalendarDate(anchor)||!Number.isInteger(occurrence)||occurrence<0||!Number.isInteger(rule.interval)||rule.interval<1||rule.interval>365)throw new Error("Ungültiger Wiederholungstermin.");
  const date=new Date(anchor+"T12:00:00Z"),amount=rule.interval*occurrence;
  if(rule.unit==="day"||rule.unit==="week")date.setUTCDate(date.getUTCDate()+amount*(rule.unit==="week"?7:1));
  else {
    const day=date.getUTCDate();date.setUTCDate(1);
    date.setUTCMonth(date.getUTCMonth()+amount*(rule.unit==="year"?12:1));
    const last=new Date(Date.UTC(date.getUTCFullYear(),date.getUTCMonth()+1,0)).getUTCDate();
    date.setUTCDate(Math.min(day,last));
  }
  if(!Number.isFinite(date.getTime())||date.getUTCFullYear()>9999)throw new Error("Wiederholung liegt außerhalb des unterstützten Datumsbereichs.");
  return date.toISOString().slice(0,10);
}
